import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function FadeIn({ children, className = "", delay = 0, y = 24, once = true, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
